var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTrendDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_586_23",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 512H512V-1.52588e-05H0V512Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_586_23)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.751 399.085C514.082 390.754 514.082 377.246 505.751 368.915L303.085 166.249C294.754 157.918 281.246 157.918 272.915 166.249L181.333 257.83L36.4183 112.915C28.087 104.585 14.5795 104.585 6.24837 112.915C-2.08281 121.246 -2.08281 134.754 6.24837 143.085L166.248 303.085C174.58 311.416 188.087 311.416 196.418 303.085L288 211.503L475.582 399.085C483.913 407.416 497.421 407.416 505.751 399.085Z",
    fill: "#E7454A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.333 384C341.333 395.782 350.884 405.333 362.667 405.333H490.667C502.449 405.333 512 395.782 512 384V256C512 244.218 502.449 234.667 490.667 234.667C478.884 234.667 469.333 244.218 469.333 256V362.667H362.667C350.884 362.667 341.333 372.218 341.333 384Z",
    fill: "#E7454A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 512)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendDown);
export default __webpack_public_path__ + "static/media/arrow-trend-down.02b042637a7c7e4b37d94bfbaeeee25f.svg";
export { ForwardRef as ReactComponent };